import httpClient from './httpClient';

const getUser = ({ options }) => httpClient.get('/api/auth/me/', options).then((resp) => resp.data);

export default {
  getUser,
};
